export enum SplitCommissionsReport {
  PLANNED_IN_OPEN_BATCH = "PLANNED_IN_OPEN_BATCH",
  PLANNED_IN_FINISHED_BATCH = "PLANNED_IN_FINISHED_BATCH",
  INCLUDED_IN_BATCH = "INCLUDED_IN_BATCH",
  PAID = "PAID",
}

export enum SplitCommissionsOrderByColumn {
  PAYMENT_PERIOD = "PAYMENT_PERIOD",
  COMMISSION_AMOUNT = "COMMISSION_AMOUNT",
  ORIGINAL_COMMISSION_BASE_AMOUNT = "ORIGINAL_COMMISSION_BASE_AMOUNT",
  ORIGINAL_BATCH_NAME = "ORIGINAL_BATCH_NAME",
}
